import { useDpFanRecommendedContent } from '@/data/Content/DpFan/fetcherContent';
import { NullElement } from '@/components/blocks/NullElement';
import { RenderContent } from '@/components/blocks/RenderContent';
import valueIsNullOrUndef from 'integration/utils/typeAssertions/valueIsNullOrUndef';

interface Props {
	emsName: string;
	loadingElement?: JSX.Element;
	emptyElement?: JSX.Element;
}

export const DpFanRecommendedContent: React.FC<Props> = ({
	emsName,
	loadingElement = <NullElement />,
	emptyElement = <NullElement />,
}) => {
	const { processedContent, isLoadingUserInterests, isLoadingContentRecommendation } =
		useDpFanRecommendedContent(emsName);

	if (isLoadingContentRecommendation || isLoadingUserInterests) {
		return loadingElement;
	}

	if (processedContent?.length === 0 || valueIsNullOrUndef(processedContent)) {
		return emptyElement;
	}

	return (
		<>
			{processedContent?.map((content) => (
				<RenderContent key={`${content.id}${content.contentId}`} content={content} />
			))}
		</>
	);
};
